"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProducts = void 0;
const get_products_stream_1 = require("./get-products-stream");
const routes_1 = require("../../routes");
const stream_1 = require("../../stream");
const getProducts = (client) => async (query) => {
    if (!query?.limit && !query?.page && query?.is_indexable) {
        return (0, stream_1.unwrapStream)(await (0, get_products_stream_1.getProductsStreamResponse)(client)(query));
    }
    const { page, limit, ...bodyParams } = query || {};
    const params = new URLSearchParams();
    if (page !== undefined)
        params.append('page', String(page));
    if (limit !== undefined)
        params.append('limit', String(limit));
    const url = params.toString() ? `${routes_1.ENDPOINTS.GET_PRODUCTS.path}?${params.toString()}` : routes_1.ENDPOINTS.GET_PRODUCTS.path;
    const response = await client.post(url, {
        ...bodyParams,
        _id: bodyParams._id ? (Array.isArray(bodyParams._id) ? bodyParams._id : [bodyParams._id]) : undefined,
        ean_code: bodyParams.ean_code
            ? Array.isArray(bodyParams.ean_code)
                ? bodyParams.ean_code
                : [bodyParams.ean_code]
            : undefined,
    });
    return response.data;
};
exports.getProducts = getProducts;
